<style>
@import '../../assets/css/report.css';
</style>

<template>
    <div class="main-panel">
        <div class="main-content">
            <div class="container-fluid">
                <b-card :header="$t('button.search')" header-tag="header" class="mb-3">
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_start')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.dateStart"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_date_end')}}</template>
                        <b-input-group>
                            <b-input-group-text slot="append"><i class='dripicons-calendar'></i></b-input-group-text>
                            <b-form-input type="date" v-model="ajaxSearch.dateEnd"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label">{{$t('admin.table_day')}}</template>
                        <b-button variant="primary" @click="searchDate('3days')" class="mr-2 mt-1">3 {{$t('admin.table_day')}}</b-button>
                        <b-button variant="primary" @click="searchDate('thisweek')" class="mr-2 mt-1">{{$t('admin.table_this_week')}}</b-button>
                        <b-button variant="primary" @click="searchDate('thismonth')" class="mr-2 mt-1">{{$t('admin.table_this_month')}}</b-button>
                        <b-button variant="primary" @click="searchDate('lastweek')" class="mr-2 mt-1">{{$t('admin.table_last_week')}}</b-button>
                        <b-button variant="primary" @click="searchDate('lastmonth')" class="mr-2 mt-1">{{$t('admin.table_last_month')}}</b-button>
                    </b-form-group>
                    <b-form-group label-cols="12" label-cols-lg="4">
                        <template slot="label"></template>
                        <b-button variant="primary" @click="initialize()">{{$t('button.search')}}</b-button>
                    </b-form-group>
                </b-card>
                <b-card :header="$t($route.name)" class="mt-3">
                    <el-table class="custom-table" :data="ajaxTable" ref="tableTest" border>
                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" :min-width="title.width"></el-table-column>
                    </el-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import {userAjaxTable} from '@/system/model/report'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader','reload'],
    data(){
        return{   
            ajaxLoad:false,
            ajaxTable:[],
            ajaxRow:'',
            titles:[],   
            ajaxSearch:{dateStart:'',dateEnd:'',},
        }
    },methods:{
        initialize(){
            var self = this;
            var result = userAjaxTable(this.ajaxSearch.dateStart,this.ajaxSearch.dateEnd);
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.ajaxTable = value.data.data;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.titles = value.data.tab_title;
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },defaultDate(){
            var today = new Date();
            this.ajaxSearch.dateStart = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-01';
            this.ajaxSearch.dateEnd = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + (today.getDate())).slice(-2);
        },searchDate(date){
            var today = new Date();
            var todayDate = today.getDate();
            var todayMonth = today.getMonth();
            var todayYear = today.getFullYear();
            var filter = new Date();
            var filterDate;
            var filterMonth;
            var filterYear;

            if(date == '3days'){
                filter.setDate(filter.getDate() - 3);
                filterDate = filter.getDate();filterMonth = filter.getMonth();filterYear = filter.getFullYear();
            }else if(date == 'thisweek'){
                filter.setDate(filter.getDate() - 7);
                filterDate = filter.getDate();filterMonth = filter.getMonth();filterYear = filter.getFullYear();
            }else if(date == 'thismonth'){
                filterDate = 1;filterMonth = filter.getMonth();filterYear = filter.getFullYear();
                todayDate = 31;
            }else if(date == 'lastweek'){
                filter.setDate(filter.getDate() - 14);
                today.setDate(today.getDate() - 7);
                filterDate = filter.getDate();filterMonth = filter.getMonth();filterYear = filter.getFullYear();
                todayDate = today.getDate();todayMonth = today.getMonth();todayYear = today.getFullYear();
            }else if(date == 'lastmonth'){
                filterDate = 1;filterMonth = filter.getMonth()-1;filterYear = filter.getFullYear();
                todayDate = 31;todayMonth = today.getMonth()-1
            }
            this.ajaxSearch.dateStart = filterYear + '-' + ('0' + (filterMonth + 1)).slice(-2) + '-' + ('0' + filterDate).slice(-2);
            this.ajaxSearch.dateEnd = todayYear + '-' + ('0' + (todayMonth + 1)).slice(-2) + '-' + ('0' + todayDate).slice(-2);
            // (defaultDays)?this.initialize():'';
        }
    },created(){
        this.preloader(false);
        this.defaultDate();
        this.initialize();
    }
}
</script>
